import { gql } from '@apollo/client'

export const EDIT_USER = gql`
  mutation EditUser($input: UpdateUserInformationInput!) {
    updateUserInformation(input: $input) {
      __typename
      ... on UpdateUserSuccess {
        user {
          id
          lastName
          firstName
        }
      }
      ... on UpdateUserFailure {
        errorMessage
        fieldsErrors {
          field
          messages
        }
      }
    }
  }
`
export const LOGOUT_USER = gql`
  mutation Logout {
    logout(input: {}) {
      ... on LogoutSuccess {
        result
      }
      ... on LogoutFailure {
        errorMessage
        fieldsErrors {
          field
          messages
        }
      }
    }
  }
`
export const RESET_USER_PASSWORD = gql`
  mutation resetPassword(
    $userId: Int!
    $resetToken: String!
    $password: String!
    $confirmPassword: String!
  ) {
    resetPassword(
      input: {
        userId: $userId
        resetToken: $resetToken
        password: $password
        confirmPassword: $confirmPassword
      }
    ) {
      ... on ResetPasswordSuccess {
        user {
          id
          email
        }
      }
      ... on ResetPasswordFailure {
        errorMessage
        fieldsErrors {
          field
          messages
        }
      }
    }
  }
`
export const LOGIN_USER = gql`
  mutation Login($email: String!, $password: String!, $partnerSlug: String!, $cartId: ID) {
    login(
      input: { email: $email, password: $password, partnerSlug: $partnerSlug, cartId: $cartId }
    ) {
      ... on LoginSuccess {
        user {
          pk
          id
          email
          type {
            name
            permissions
          }
          lastName
          firstName
          fullName
          phoneNumber
          isPhoneNumberVerified
        }
      }
      ... on LoginFailure {
        errorMessage
        fieldsErrors {
          field
          messages
        }
      }
    }
  }
`
export const SIGN_UP_AS_GUEST = gql`
  mutation SignUpGuest($input: SignupGuestInput!) {
    signupGuest(input: $input) {
      ... on SignupSuccess {
        user {
          id
          pk
          firstName
          lastName
          email
          phoneNumber
          locationCountry
        }
      }
      ... on SignupFailure {
        errorMessage
        fieldsErrors {
          field
          messages
        }
      }
    }
  }
`
export const RECOVER_PASSWORD = gql`
  mutation recoverPassword($email: String!) {
    recoverPassword(input: { email: $email }) {
      ... on RecoverPasswordSuccess {
        result
      }
      ... on RecoverPasswordFailure {
        errorMessage
        fieldsErrors {
          field
          messages
        }
      }
    }
  }
`
export const REGISTRATION = gql`
  mutation Registration(
    $firstName: String!
    $lastName: String!
    $email: String!
    $password: String!
    $newsletter: Boolean!
    $terms: Boolean!
    $partnerSlug: String!
    $recaptchaToken: String
    $referralCode: String
  ) {
    signup(
      input: {
        firstName: $firstName
        lastName: $lastName
        email: $email
        password: $password
        newsletter: $newsletter
        terms: $terms
        partnerSlug: $partnerSlug
        recaptchaToken: $recaptchaToken
        referralCode: $referralCode
      }
    ) {
      ... on SignupFailure {
        errorMessage
        fieldsErrors {
          field
          messages
        }
      }
      ... on SignupSuccess {
        user {
          pk
          id
          email
          type {
            name
            permissions
          }
          lastName
          firstName
          fullName
          phoneNumber
          isPhoneNumberVerified
        }
      }
    }
  }
`
export const SET_USER_DATE_OF_BIRTH = gql`
  mutation SetUserDateOfBirth($input: SetDateOfBirthInput!) {
    setDateOfBirth(input: $input) {
      __typename
      ... on SetDateOfBirthSuccess {
        dateOfBirth
      }
      ... on SetDateOfBirthFailure {
        errorMessage
      }
    }
  }
`
export const USER_FOLLOWED_VENUES = gql`
  query FollowedVenues {
    currentUser {
      id
      type
      followedVenues {
        edges {
          node {
            id
            slug
            name
            venuePhoto {
              path
              extension
            }
          }
        }
      }
    }
  }
`
export const REGISTRATION_SHORT = gql`
  mutation RegistrationShort(
    $email: String!
    $password: String!
    $firstName: String!
    $lastName: String!
    $newsletter: Boolean!
    $terms: Boolean!
    $partnerSlug: String!
    $recaptchaToken: String
  ) {
    signup(
      input: {
        firstName: $firstName
        lastName: $lastName
        email: $email
        password: $password
        newsletter: $newsletter
        terms: $terms
        partnerSlug: $partnerSlug
        recaptchaToken: $recaptchaToken
      }
    ) {
      ... on SignupFailure {
        errorMessage
        fieldsErrors {
          field
          messages
        }
      }
      ... on SignupSuccess {
        user {
          id
          pk
          firstName
          lastName
          email
          phoneNumber
          locationCountry
        }
      }
    }
  }
`
export const CREATE_ADDRESS = gql`
  mutation AddAddress(
    $fullName: String!
    $country: Countries!
    $address: String!
    $city: String!
    $state: String
    $zipcode: String!
    $phone: String!
    $isBilling: Boolean
    $email: String
  ) {
    addUserAddress(
      input: {
        country: $country
        address: $address
        city: $city
        state: $state
        zipcode: $zipcode
        phone: $phone
        fullName: $fullName
        isBilling: $isBilling
        email: $email
      }
    ) {
      ... on AddUserAddressFailure {
        errorMessage
        fieldsErrors {
          field
          messages
        }
      }

      ... on AddUserAddressSuccess {
        address {
          id
          pk
          isTrade
          country
          address
          city
          state
          zipcode
          phone
          status
          fullName
          isBilling
          email
        }
      }
    }
  }
`
export const DELETE_ADDRESS = gql`
  mutation DeleteAddress($addressId: ID!) {
    removeUserAddress(input: { id: $addressId }) {
      id
    }
  }
`
export const EDIT_ADDRESS = gql`
  mutation EditAddress(
    $fullName: String!
    $addressId: ID!
    $country: Countries!
    $address: String!
    $city: String!
    $state: String
    $zipcode: String!
    $phone: String!
    $isBilling: Boolean
    $email: String
  ) {
    updateUserAddress(
      input: {
        id: $addressId
        country: $country
        address: $address
        city: $city
        state: $state
        zipcode: $zipcode
        phone: $phone
        fullName: $fullName
        isBilling: $isBilling
        email: $email
      }
    ) {
      ... on UpdateUserAddressFailure {
        errorMessage
        fieldsErrors {
          field
          messages
        }
      }

      ... on UpdateUserAddressSuccess {
        address {
          id
          country
          address
          city
          state
          zipcode
          phone
          status
          fullName
          isBilling
          email
        }
      }
    }
  }
`
export const GET_NOTIFICATIONS = gql`
  query UserNotifications {
    currentUser {
      id
      notifyOnNewWorks
    }
  }
`
